import React, { useEffect, useState } from 'react';
import axios from '../../util/Api';
import Table from '../../components/Table/Basic';
import Date from '../../components/Formatter/Date';
import DeleteButton from './DeleteButton';

const History = ({ id }) => {
  const [loading, setLoading] = useState(true);
  const [histories, setHistories] = useState([]);
  const [total, setTotal] = useState(null);

  useEffect(() => {
    fetchViolationHistories();
  }, [id]);

  const fetchViolationHistories = () => {
    setLoading(true);
    const url = `/violation/list?passport=${id}`;
    axios.get(url).then(resp => {
      setHistories(resp.data.violation);
      setTotal(resp.data.total);
      setLoading(false);
    }).catch(err => {});
  }

  const columns = [
    {
      title: "Perusahaan",
      key: "vendor",
      render: record => record.passport.vendor.name,
    },
    {
      title: "Proyek",
      key: 'project',
      render: record => record.passport_project.project.name
    },
    {
      title: "Tanggal Kejadian",
      key: 'date',
      render: record => <Date value={record.date}/>
    },
    {
      title: "Berlaku Sampai",
      key: 'expiry_date',
      render: record => <Date value={record.expiry_date}/>
    },
    {
      title: "Jenis Pelanggaran",
      key: 'level',
      render: record => record.level.label
    },
    {
      title: "Remark",
      key: 'remark',
      render: record => record.remark
    },
    {
      title: "",
      key: 'action',
      render: record => {
        return (
          <>
            <DeleteButton id={record.id}/>
          </>
        );
      }
    }
  ];

  return (
    <>
      <h4 className="gx-mb-3">Riwayat Pelanggaran</h4>
      <Table
        columns={columns}
        dataSource={histories}
        loading={loading}
        total={total}
        showSorterTooltip
        pathname="/violation"
        sticky
      />
    </>
  );
}

export default History;